import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
import { Base44Logo } from './Base44Logo';
import s from './Base44VoucherCard.scss';
import { useBase44VoucherExposedBiEvent } from './useBase44VoucherExposedBiEvent';
const BASE44_VOUCHER_DISCOUNT_PERCENT = 50;
export const Base44VoucherCard = _ref => {
  let {
    productId,
    isMobile = false
  } = _ref;
  const module = useCurrentModule();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  useBase44VoucherExposedBiEvent(productId);
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: `base44-voucher-card-${productId}`,
    className: s.voucherWrapper,
    direction: "vertical",
    verticalAlign: "bottom"
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.voucherCard,
    direction: "vertical",
    gap: "4px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Base44Logo, null), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, "Base 44")), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "premium-purchase-plan.eclipse.base44.offer",
    values: {
      percent: BASE44_VOUCHER_DISCOUNT_PERCENT
    },
    components: {
      highlight: /*#__PURE__*/React.createElement("span", {
        className: s.offer
      })
    }
  })), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true
  }, t('premium-purchase-plan.eclipse.base44.description'), !isMobile && /*#__PURE__*/React.createElement(Tooltip, {
    inline: true,
    placement: "right",
    maxWidth: 300,
    className: s.tooltip,
    content: /*#__PURE__*/React.createElement(Text, {
      size: "small",
      secondary: true
    }, t('premium-purchase-plan.eclipse.base44.tooltip'))
  }, /*#__PURE__*/React.createElement(Box, {
    inline: true,
    className: s.tooltipTrigger,
    dataHook: "base44-voucher-tooltip"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    size: "18",
    color: "var(--wds-color-black-100)"
  }))))));
};
//# sourceMappingURL=Base44VoucherCard.js.map